<template>
  <adv-setup>
    <div id="infusionSearchModal">
      <adv-popupForm
        :key="popupKey"
        :title="i18nJS['drug_search']"
        :contentSlot="true"
        :dimension="'small'"
        :opened="popupOpened"
        :setupConfig="setupConfig"
        @advFormSend="setDrug"
        v-if="loaded"
      >
        <template v-slot:content>
          <div class="control-group">
            <div class="controls form-inline">
              <label for="search_nomecommerciale" class="radio">
                <input
                  type="radio"
                  :value="drugsNameUrl"
                  name="search"
                  id="search_nomecommerciale"
                  checked
                  class="search-drug"
                  @change="setSearchUrl"
                />
                {{ i18nJS['nome_commerciale'] }}
              </label>
              <label for="search_descrprincipioattivo" class="radio">
                <input
                  type="radio"
                  :value="drugsDescriptionUrl"
                  name="search"
                  id="search_descrprincipioattivo"
                  class="search-drug"
                  @change="setSearchUrl"
                />
                {{ i18nJS['descr_principio_attivo'] }}
              </label>
            </div>
          </div>
          <div class="control-group field">
            <label class="control-label">{{ i18nJS['drug_search'] }}</label>
            <div>
              <v-select2 class="input-xlarge" :data-ajax--url="drugSearchUrl" v-model="selectedDrug" />
            </div>
          </div>
        </template>
      </adv-popupForm>
    </div>
  </adv-setup>
</template>
<script>
import vSelect2 from '../vSelect2';
import { advPopupForm } from '§/components/popupForm';
import { LabelApi } from '@/epersonam/mixins/labels.js';

export default {
  name: 'InfusionSearchDrugs',
  props: ['index', 'drugsDescriptionUrl', 'drugsNameUrl', 'popupKey', 'popupOpened'],
  mixins: [LabelApi],
  components: {
    vSelect2,
    advPopupForm,
  },
  data() {
    return {
      drugSearchUrl: this.drugsNameUrl,
      loaded: false,
      selectedDrug: {},
      setupConfig: {
        labels: {
          revert: 'Annulla',
          save: 'Salva',
        },
      },
    };
  },
  async beforeMount() {
    this.neededlabels = ['nome_commerciale', 'descr_principio_attivo', 'drug_search'];
    await this.setupLabels();
    this.loaded = true;
  },
  methods: {
    setSearchUrl(event) {
      this.drugSearchUrl = event.target.value;
    },
    setDrug() {
      this.$emit('setDrug', this.selectedDrug);
    },
  },
};
</script>

<style lang="scss">
#infusionSearchModal {
  .adv-popupForm--small {
    .adv-layer {
      max-height: 300px !important;
    }
  }
}
</style>
